/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_UnmuteInputs */

const en_playbar_unmute = /** @type {(inputs: Playbar_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmute`)
};

const es_playbar_unmute = /** @type {(inputs: Playbar_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar sonido`)
};

/**
* | output |
* | --- |
* | "Unmute" |
*
* @param {Playbar_UnmuteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_unmute = /** @type {((inputs?: Playbar_UnmuteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_UnmuteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_unmute(inputs)
	return en_playbar_unmute(inputs)
});